<template>
  <span>
    <label for="paymentDiscountCode" class="optional">{{ $t('paymentSelection.discountCodeLabel') }}</label>
    <input id="paymentDiscountCode" v-model="discountCode" type="text" name="paymentDiscountCode" class="discount-code"
           maxlength="30">
    <ul v-if="discountCodeInvalid" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
      <li>{{ $t('paymentSelection.validation.discountCode.' + discountCodeReason) }}</li>
    </ul>
    <a id="calculateDiscountLink" class="calculate-discount" href="javascript:void(0);" @click.prevent="applyDiscountCode">
      {{ $t('paymentSelection.applyDiscountCodeButton') }}
    </a>
  </span>
</template>

<script>
import { VALIDATION_ERROR_NAME } from '../../order-api/error/validation-error'

export default {
  name: 'DiscountCodeRow',
  data () {
    return {
      discountCode: null,
      discountCodeInvalid: false,
      discountCodeReason: null
    }
  },
  mounted () {
    this.discountCode = this.$store.getters['cart/orderDiscountCode']
  },
  methods: {
    applyDiscountCode: async function () {
      if (this.discountCode) {
        try {
          await this.$store.dispatch('cart/addDiscountCode', this.discountCode)
          this.discountCodeInvalid = false
          this.discountCodeReason = null
        } catch (error) {
          let errorCode = 'unknown'
          if (error.name === VALIDATION_ERROR_NAME && error.errors.length > 0) {
            errorCode = error.errors[0].code
          }
          this.discountCodeInvalid = true
          this.discountCodeReason = errorCode
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment-selection/DiscountCodeRow.vue